import styled from '@emotion/styled';
import { Outlet } from '@tanstack/react-router';
import { Suspense } from 'react';
import { ErrorBoundary, FeatureErrorFallback } from '@/components/ui/ErrorBoundary';
import { LoadingSpinner } from '@/components/ui/LoadingSpinner';
import { colors } from '@/lib/design-tokens';
import { Header } from './Header';
import { Sidebar } from './Sidebar';

const LayoutContainer = styled.div`
  display: flex;
  min-height: 100vh;
  background-color: ${colors.neutral[50]};
`;

const ContentWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

const Main = styled.main`
  flex: 1;
  overflow-y: auto;
`;

const MainInner = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 24px;
`;

function AppLayout() {
  return (
    <LayoutContainer>
      <Sidebar />
      <ContentWrapper>
        <Header />
        <Main>
          <MainInner>
            <ErrorBoundary
              fallbackRender={({ error, resetErrorBoundary }) => (
                <FeatureErrorFallback error={error} resetErrorBoundary={resetErrorBoundary} />
              )}
            >
              <Suspense fallback={<LoadingSpinner size="large" label="読み込み中..." />}>
                <Outlet />
              </Suspense>
            </ErrorBoundary>
          </MainInner>
        </Main>
      </ContentWrapper>
    </LayoutContainer>
  );
}

export { AppLayout };
